import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 40000-40999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const pdfExportErrors = {
  // 40xxx is the pdfExport module's series. One site stays generic: it forwards a caught error's
  // own text, which the handler also substring-tests to pick its HTTP status.
  // 40001-40005 — the pdfExport module's split.
  PDF_EXPORT_JOBS_LOAD_FAILED: {
    errorCode: 40001,
    errorMessage: t("Your PDF export jobs could not be loaded."),
    isDynamic: false,
  },
  PDF_EXPORT_JOB_NOT_FOUND: {
    errorCode: 40002,
    errorMessage: t("Export job not found."),
    isDynamic: false,
  },
  PDF_EXPORT_NOT_READY: {
    errorCode: 40003,
    errorMessage: t("This export is not ready to download yet."),
    isDynamic: false,
  },
  PDF_EXPORT_FILE_NO_LONGER_AVAILABLE: {
    errorCode: 40004,
    errorMessage: t("The exported PDF is no longer available."),
    isDynamic: false,
  },
  PDF_EXPORT_DOWNLOAD_FAILED: {
    errorCode: 40005,
    errorMessage: t("The PDF could not be downloaded."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
